import { SortedDeliveryOptions } from './index';

export const getStripePaymentRequest = (
  amount: number,
  displayPrice: number,
  deliveryAmount: number,
  deliveryOptions: SortedDeliveryOptions[]
) => ({
  country: 'GB',
  currency: 'gbp',
  total: {
    label: 'Total',
    amount,
  },
  requestPayerName: true,
  requestPayerEmail: true,
  requestPayerPhone: true,
  displayItems: [
    {
      amount: displayPrice,
      label: 'Sub Total',
    },
    {
      amount: deliveryAmount,
      label: 'Packaging & Delivery',
    },
  ],
  requestShipping: true,
  shippingOptions: deliveryOptions,
});

export const getDetailsOnShippingChange = (
  amount: number,
  displayPrice: number,
  shippingAmount: number
) => {
  return {
    status: 'success',
    total: {
      label: 'Total',
      amount,
    },
    displayItems: [
      {
        amount: displayPrice,
        label: 'Sub Total',
      },
      {
        amount: shippingAmount,
        label: 'Packaging & Delivery',
      },
    ],
  };
};

export const postToStripePaymentRequestApi = async (postData) => {
  const response = await fetch('/checkout/apistripepaymentrequest', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(postData),
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch ${response.status} - ${response.statusText}`);
  }

  const json = await response.json();

  if (json.Status === 'Error' || json.Status === 'Exception') {
    throw new Error(json.Alert.Message);
  }

  return true;
};
